import { render } from "./buy-more.vue?vue&type=template&id=14b5984e&scoped=true&ts=true"
import script from "./buy-more.vue?vue&type=script&lang=ts"
export * from "./buy-more.vue?vue&type=script&lang=ts"

import "./buy-more.vue?vue&type=style&index=0&id=14b5984e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b5984e"]])

export default __exports__